export const organesRoutes = {
  name: "Commissions root",
  path: "organes",
  redirect: () => ({ name: "Commissions et autres organes" }),
  children: [
    {
      name: "Commissions et autres organes",
      path: "",
      component: () =>
        import("@follaw-fr/views/side_menu_views/CommissionsView.vue"),
    },
    {
      name: "Commissions et autres organes - Follawed",
      path: "follawed",
      component: () =>
        import("@follaw-fr/views/side_menu_views/CommissionsView.vue"),
    },
    {
      name: "Zoom Commission ou autre organe",
      path: ":_id",
      component: () =>
        import("@follaw-fr/views/side_menu_views/CommissionZoomView.vue"),
      children: [
        {
          name: "Zoom Commission - Composition",
          path: "composition",
          component: () =>
            import("@follaw-fr/views/institutional-groups/CompositionView.vue"),
        },
        {
          name: "Zoom Commission - Activités",
          path: "activites",
          component: () =>
            import("@follaw-fr/views/institutional-groups/LastActivities.vue"),
        },
        {
          name: "Zoom Commission - Publications",
          path: "publications",
          component: () =>
            import(
              "@follaw-fr/views/institutional-groups/PublicationsView.vue"
            ),
        },
        {
          name: "Zoom Commission - Missions",
          path: "missions",
          component: () =>
            import("@follaw-fr/views/institutional-groups/MissionsView.vue"),
          children: [],
        },
        {
          path: "agenda",
          component: () =>
            import("@follaw-fr/views/institutional-groups/AgendaView.vue"),
        },
        {
          path: "petitions",
          component: () =>
            import("@follaw-fr/views/institutional-groups/PetitionsView.vue"),
        },
      ],
    },
    {
      name: "Zoom Mission d'une Commission",
      path: "/organes/:_id/mission/:missionId",
      component: () =>
        import("@follaw-fr/views/institutional-groups/MissionZoomView.vue"),
      children: [
        {
          name: "Zoom Mission - Composition",
          path: "composition",
          component: () =>
            import("@follaw-fr/views/institutional-groups/CompositionView.vue"),
        },
        {
          name: "Zoom Mission - Activités",
          path: "activites",
          component: () =>
            import("@follaw-fr/views/institutional-groups/LastActivities.vue"),
        },
        {
          name: "Zoom Mission - Publications",
          path: "publications",
          component: () =>
            import(
              "@follaw-fr/views/institutional-groups/PublicationsView.vue"
            ),
        },
        {
          path: "agenda",
          component: () =>
            import("@follaw-fr/views/institutional-groups/AgendaView.vue"),
        },
      ],
    },
  ],
};
